$(document).ready(function () {
  const currentLocale = getCurrentLocale();

  $('#payinAmount').on('keyup', function() {
    if(this.value.length != 0) {
      const feesMessage = { fr: 'Frais', en: 'Fees', es: 'Tarifas' };
      const amount      = parseFloat(this.value);
      const fees_rate   = $('#feesAmount').data('fees');
      const fees_amount = (amount * (fees_rate / 100));
      const total       = (fees_amount + amount).toFixed(2);

      if(fees_rate > 0) {
        $('#feesAmount').text(
          feesMessage[currentLocale] + ' ' + fees_amount.toFixed(2) + '€'
        );
      }

      $('#totalAmount').text(total + ' ' + '€')

      $('#creditBtn').prop('disabled', false);
    } else {
      $('#feesAmount').text('');
      $('#creditBtn').prop('disabled', true);
    }
  })
})
